module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "g-bd"
  }, [_c('div', {
    staticClass: "m-tlt"
  }, [_vm._v("登录前请先验证将军令动态密码")]), _vm._v(" "), _c('Form', {
    staticClass: "m-form"
  }, [_c('form-item', {
    ref: "optValidate",
    staticClass: "m-ipt ipt-h"
  }, [_c('urs-input', {
    ref: "optInput",
    attrs: {
      "placeholder": "请输入动态密码",
      "validate": _vm.validateOpt
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-btns g-pd"
  }, [_c('urs-button', {
    ref: "submitBtn",
    attrs: {
      "enableTip": "确定"
    },
    on: {
      "click": _vm.onSubmit
    }
  })], 1)], 1)], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-ft g-pd clearfix c-main"
  }, [_c('a', {
    staticClass: "f-right",
    attrs: {
      "href": "https://gj.reg.163.com/faq/p2.html?ct=04"
    }
  }, [_vm._v("将军令无法使用？")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81a0f036"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Verifyopt.vue
// module id = 521
// module chunks = 1